/* Pinflag */

// Añade variante de bolsa al carro --------------------------------------------------------------------------------
function addToCartRecommended(button) {
  const span = button.querySelector(".cart-recommendations-text-button");
  if (span) {
    span.textContent = "Añadiendo...";
  }
  const cartItem = button.closest(".cart-recommendations-cart-item ");

  const variantInput = cartItem.getElementsByClassName(
    "cart-recommendations-form-hidden"
  );
  const variantId = variantInput ? variantInput[0].value : null;

  if (variantId) {
    axios
      .post("/cart/add.js", {
        id: variantId,
        quantity: 1,
      })
      .then((response) => {
        // Producto agregado al carrito
        span.textContent = "agregar al carro";
        setTimeout(() => refreshCartDrawer(), 1000);
      })
      .catch((error) => {
        // Error al agregar el producto al carrito
      });
  } else {
    // No se encontró el variant ID
  }
}

//Actualiza visualmente el carro-----------------------------------------------------------------------------------
function refreshCartDrawer() {
  return fetch("/cart")
    .then((response) => response.text())
    .then((cart) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(cart, "text/html");

      const cartItems = doc.querySelector("#cart-items-list");

      if (cartItems) {
        const cartItemList = document.querySelector("#cart-items-list");
        cartItemList.innerHTML = cartItems ? cartItems.innerHTML : "";

        const drawerFooter = doc.querySelector(".drawer__footer");
        const drawerFooterOld = document.querySelector(".drawer__footer");
        drawerFooterOld.innerHTML = drawerFooter ? drawerFooter.innerHTML : "";

        const cartCountBubble = doc.querySelector(".cart-count-bubble");
        const cartCountBubbleOld = document.querySelector(".cart-count-bubble");
        cartCountBubbleOld.innerHTML = cartCountBubble
          ? cartCountBubble.innerHTML
          : "";
      } else {
        const cartEmpty = doc.querySelector("cart-drawer");
        const cartEmptyOld = document.querySelector("cart-drawer");
        cartEmptyOld.innerHTML = cartEmpty ? cartEmpty.innerHTML : "";

        const cartCountBubble = doc.querySelector(".cart-count-bubble");
        const cartCountBubbleOld = document.querySelector(".cart-count-bubble");
        cartCountBubbleOld.innerHTML = cartCountBubble
          ? cartCountBubble.innerHTML
          : "";
      }
    })
    .catch((error) => {/* Error updating cart drawer */});
}

document.querySelectorAll(".cart-recommendations-cart-item").forEach((card) => {
  const selectSizeButton = card.querySelector(".select-size-button");
  const addToCartButton = card.querySelector(
    ".cart-recommendations-button-add"
  );

  const closeButton = card.querySelector(".close-variants-buttons-recommended");
  const variantButtons = card.querySelector(
    ".cart-recommendations-bag-message"
  );

  selectSizeButton.addEventListener("click", () => {
    if (addToCartButton) {
      addToCartButton.setAttribute("style", "display: block !important;");
      selectSizeButton.setAttribute("style", "display: none !important;");
      variantButtons.setAttribute("style", "display: block !important;");
    }
  });

  closeButton.addEventListener("click", () => {
    if (variantButtons) {
      addToCartButton.setAttribute("style", "display: none !important;");
      selectSizeButton.setAttribute("style", "display: block !important;");
      variantButtons.setAttribute("style", "display: none !important;");
    }
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const buttons = document.querySelectorAll(
    ".card-wrapper .product-form__submit"
  );

  buttons.forEach((button) => {
    button.addEventListener("click", () => {
      const drawerInner = document.querySelector(".drawer__inner");

      if (drawerInner) {
        const hasClasses =
          drawerInner.classList.contains("cart-drawer-pinflag-flex-column") &&
          drawerInner.classList.contains("cart-drawer-pinflag-width");

        if (!hasClasses) {
          drawerInner.classList.add(
            "cart-drawer-pinflag-flex-column",
            "cart-drawer-pinflag-width"
          );
          // Clases agregadas al drawer__inner
        }
      }
    });
  });
});

document.addEventListener("DOMContentLoaded", () => {
  // Crea un observer para detectar cambios en el DOM
  const observer = new MutationObserver(() => {
    // Verifica si el elemento '.cart-recommendations-cart-item' ha aparecido
    const items = document.querySelectorAll(".cart-recommendations-cart-item");

    if (items.length > 0) {
      items.forEach((item) => {
        // Aquí puedes ejecutar la lógica para trabajar con el nuevo item
        const selectSizeButton = item.querySelector(".select-size-button");
        const addToCartButton = item.querySelector(
          ".cart-recommendations-button-add"
        );
        const closeButton = item.querySelector(
          ".close-variants-buttons-recommended"
        );
        const variantButtons = item.querySelector(
          ".cart-recommendations-bag-message"
        );

        if (
          selectSizeButton &&
          addToCartButton &&
          closeButton &&
          variantButtons
        ) {
          selectSizeButton.addEventListener("click", () => {
            if (addToCartButton) {
              addToCartButton.setAttribute(
                "style",
                "display: block !important;"
              );
              selectSizeButton.setAttribute(
                "style",
                "display: none !important;"
              );
              variantButtons.setAttribute(
                "style",
                "display: block !important;"
              );
            }
          });

          closeButton.addEventListener("click", () => {
            if (variantButtons) {
              addToCartButton.setAttribute(
                "style",
                "display: none !important;"
              );
              selectSizeButton.setAttribute(
                "style",
                "display: block !important;"
              );
              variantButtons.setAttribute("style", "display: none !important;");
            }
          });
        }
      });
    }
  });

  // Configura el observer para observar el cuerpo del documento por cambios
  const config = { childList: true, subtree: true };
  observer.observe(document.body, config);
});

// Permite estar observando si es necesario extender o no el width del carro -----------------------------------------------------------------------
document.addEventListener("DOMContentLoaded", function () {
  // Prueba
  const cartDrawer = document.querySelector("cart-drawer.drawer");
  const cartRecommendations = document.querySelector("cart-recommendations");

  if (!cartDrawer) {
    // El elemento cartDrawer no se encontró en el DOM
    return;
  }

  if (!cartRecommendations) {
    return;
  }

  function updateCart() {
    // updateCart
    const drawerInner = document.querySelector(".drawer__inner");

    if (!drawerInner) {
      // El elemento drawerInner no se encontró en el DOM
      return;
    }

    if (cartDrawer.classList.contains("is-empty")) {
      // Esta vacio
      drawerInner.style.cssText += "width: 40rem !important;";
    } else {
      drawerInner.style.cssText += "width: 72rem !important;";
      // No esta vacio
    }
  }

  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (
        mutation.type === "attributes" &&
        mutation.attributeName === "class"
      ) {
        updateCart();
      }
    });
  });

  observer.observe(cartDrawer, { attributes: true });

  updateCart();
});

/* local storage userInformation ---------------------------------------------- */
function formatRut(rut) {
  return rut.replace(/\./g, ""); // Elimina los puntos
}

function checkUserInformation() {
  const storedData = localStorage.getItem("userInformation");

  const userData = JSON.parse(storedData);
  const fullName = userData.names.split(" ");
  const first_name = fullName[0];
  const last_name = fullName.slice(1).join(" ");
  const email = userData.email;
  const rut = formatRut(userData.rut);

  // User information processed

  exponea.update({
    first_name: first_name,
    last_name: last_name,
    rut: rut,
    email: email,
  });

  exponea.identify({
    email_id: email,
  });
}

if (!window.customJsInitialized) {
  window.customJsInitialized = true;
  
  document.addEventListener("DOMContentLoaded", function () {
    // Inicializando tarjetas de producto
    initializeProductCards();
    initializeInfiniteScroll();
    initializeCartDrawer();
  });
}

function initializeProductCards() {
  // Inicializando tarjetas de producto
  const productCards = document.querySelectorAll(".product-card-wrapper");
  productCards.forEach(initializeProductCard);

  if (window.location.pathname.includes("/search")) {
    productCards.forEach((card) => {
      const defaultProductUrl = card.querySelector(".card__heading a")?.href;
      if (defaultProductUrl) {
        const cleanUrl = defaultProductUrl.split("?")[0];
        if (typeof updateVariantSelector === 'function') {
          if (typeof window.debouncedUpdateVariantSelector === 'function') {
            window.debouncedUpdateVariantSelector(card, cleanUrl, true);
          } else {
            updateVariantSelector(card, cleanUrl, true);
          }
        }
      }
    });
  }
}

function initializeProductCard(productCard) {
  const defaultProductUrl = productCard.querySelector(".card__heading a")?.href;
  if (defaultProductUrl) {
    const cleanUrl = defaultProductUrl.split("?")[0];
    // updateVariantSelector se define en color-swatches.liquid
    if (typeof updateVariantSelector === 'function') {
      if (typeof window.debouncedUpdateVariantSelector === 'function') {
        window.debouncedUpdateVariantSelector(productCard, cleanUrl);
      } else {
        updateVariantSelector(productCard, cleanUrl);
      }
    }
  }

  const defaultColorSwatch = productCard.querySelector(
    ".variant_color_swatches.select_variant"
  );
  if (defaultColorSwatch) {
    defaultColorSwatch.classList.add("selected");
    // applySelectedEffect se define en color-swatches.liquid
    if (typeof applySelectedEffect === 'function') {
      applySelectedEffect(defaultColorSwatch);
    }

    const productImage1 = productCard.querySelector(
      ".card__media .product_image_1"
    );
    const productImage2 = productCard.querySelector(
      ".card__media .product_image_2"
    );

    if (productImage1 && productImage2) {
      if (
        productImage2.src.includes("Liquid error") ||
        productImage2.srcset.includes("Liquid error")
      ) {
        productImage2.src = productImage1.src;
        productImage2.srcset = productImage1.srcset;
      }
    }
  }

  productCard.querySelectorAll(".variant_color_swatches").forEach((swatch) => {
    swatch.addEventListener("click", function (e) {
      e.preventDefault();

      if (!this.classList.contains("selected")) {
        // changeProductPLP se define en color-swatches.liquid
        if (typeof changeProductPLP === 'function') {
          if (typeof window.debouncedChangeProductPLP === 'function') {
            window.debouncedChangeProductPLP(this);
          } else {
            changeProductPLP(this);
          }
        }
      }
    });
  });

  const addToCartForm = productCard.querySelector(".product-form");
  if (addToCartForm) {
    addToCartForm.addEventListener("submit", function(event) {
      // handleAddToCart se define en color-swatches.liquid
      if (typeof handleAddToCart === 'function') {
        handleAddToCart(event);
      }
    });
  }
}

function initializeInfiniteScroll() {
  const infiniteScrollElement = document.querySelector("infinite-scroll");
  if (infiniteScrollElement) {
    infiniteScrollElement.addEventListener("productsLoaded", function (event) {
      const newProducts = event.detail.newProducts;
      newProducts.forEach(initializeProductCard);
    });
  }
}

function initializeCartDrawer() {
  const cartDrawer = document.querySelector("cart-drawer");
  if (cartDrawer) {
    if (!cartDrawer.open) {
      cartDrawer.open = function () {
        this.classList.add("animate", "active");
        document.body.classList.add("overflow-hidden");
      };
    }

    if (!cartDrawer.close) {
      cartDrawer.close = function () {
        this.classList.remove("active");
        document.body.classList.remove("overflow-hidden");
      };
    }

    const overlay = cartDrawer.querySelector("#CartDrawer-Overlay");
    if (overlay) {
      overlay.addEventListener("click", () => cartDrawer.close());
    }
  }
}

function initAccordionMetafields(event) {
  const root = event?.target || document;

  function splitItems(textContent, htmlContent, specsType) {
    const brRegex = /<br\s*\/?>/i;
    if (brRegex.test(htmlContent)) {
      return htmlContent.split(brRegex).filter(Boolean);
    }
    if (textContent.includes('\n')) {
      return textContent.split(/\r?\n/);
    }
    if (textContent.includes('·')) {
      return textContent.split('·').map((item) => item.trim()).filter(Boolean);
    }

    if (specsType === 'composition') {
      const keyValueItems = textContent.split(/\s+(?=[A-Z][a-záéíóúñ]+:)/);
      if (keyValueItems.length > 1) return keyValueItems.map((s) => s.trim()).filter(Boolean);
    }

    const items = [];
    textContent.split(/\s{2,}/).forEach((section) => {
      const s = section.trim();
      if (!s) return;
      let chunks;
      try {
        chunks = s.split(/(?<=\))\s+(?=[A-Z])/);
      } catch (e) {
        chunks = [s];
      }
      chunks.forEach((chunk) => {
        const c = chunk.trim();
        if (!c) return;
        c.split(/\.\s+(?=[A-Z0-9][^\.:]+:)/).forEach((sub) => {
          const item = sub.trim();
          if (item) items.push(item);
        });
      });
    });
    return items.length ? items : [textContent];
  }

  root.querySelectorAll('.product-info-list').forEach((infoList) => {
    const rawContent = infoList.nextElementSibling;
    if (!rawContent || !rawContent.classList.contains('product-raw-content')) return;

    const htmlContent = rawContent.innerHTML.trim();
    const textContent = rawContent.textContent.trim();
    if (!htmlContent && !textContent) return;

    const specsType = infoList.dataset.specsType;
    const items = splitItems(textContent, htmlContent, specsType);
    infoList.innerHTML = '';

    items.forEach((item) => {
      const cleanItem = item.replace(/^-\s*/, '').replace(/\s*-$/, '').trim();
      if (!cleanItem) return;

      const li = document.createElement('li');
      const strippedItem = cleanItem.replace(/^·\s*/, '');
      const colonIndex = strippedItem.indexOf(':');

      if (colonIndex > 0) {
        const key = strippedItem.substring(0, colonIndex);
        const value = strippedItem.substring(colonIndex + 1);
        const strong = document.createElement('strong');
        strong.textContent = key;
        li.appendChild(strong);
        li.appendChild(document.createTextNode(':' + value));
      } else {
        li.textContent = strippedItem;
      }

      infoList.appendChild(li);
    });
  });
}

document.addEventListener('DOMContentLoaded', initAccordionMetafields);
document.addEventListener('shopify:section:load', initAccordionMetafields);

/* Flash sale countdown */
(function () {
  const pad = n => String(n).padStart(2, '0');

  function formatCountdown(ms) {
    if (ms <= 0) return null;
    const days    = Math.floor(ms / 86400000);
    const hours   = Math.floor((ms % 86400000) / 3600000);
    const minutes = Math.floor((ms % 3600000) / 60000);
    const seconds = Math.floor((ms % 60000) / 1000);
    if (days > 0) return `${days}d ${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
    return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
  }

  function updateCountdowns() {
    document.querySelectorAll('[data-expiration]').forEach(el => {
      const expirationTimestamp = parseInt(el.dataset.expiration, 10);
      if (isNaN(expirationTimestamp)) return;
      const expiration = expirationTimestamp * 1000;
      const remaining  = expiration - Date.now();
      const timer      = el.querySelector('.sale-countdown__timer');
      if (!timer) return;
      const formatted  = formatCountdown(remaining);
      if (!formatted) {
        el.style.display = 'none';
      } else {
        timer.textContent = formatted;
      }
    });
  }

  updateCountdowns();
  setInterval(updateCountdowns, 1000);
})();
